import React, { Suspense, lazy, useEffect } from "react";
import { motion } from "framer-motion";

// Lazy load components
const NeeteshHeroSection = lazy(() => import("../components/neeteshTour/NeeteshHeroSection"));
const NeeteshCitiesGrid = lazy(() => import("../components/neeteshTour/NeeteshCitiesGrid"));
const BenefitsSection = lazy(() => import("../components/bookATour/BenefitsSection"));
const ContactSection = lazy(() => import("../components/bookATour/ContactSection"));

// Loading fallback component
const LoadingFallback = () => (
  <div
    style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#f8f9fa",
    }}
  >
    <div className="loading-spinner" />
  </div>
);

const NeeteshTour = () => {
  useEffect(() => {
    // Update page title and meta description for SEO
    document.title = "Neetesh Jung Kunwar USA Tour 2025 - 3E Entertainment";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Book Neetesh Jung Kunwar for your venue! Available October - December 2025. Confirmed at DT Fest Ashburn on October 4th. Experience the best of Nepalese entertainment.');
    }
    
    // Update Open Graph title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Neetesh Jung Kunwar USA Tour 2025 - 3E Entertainment');
    }
    
    // Update Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Book Neetesh Jung Kunwar for your venue! Available October - December 2025. Confirmed at DT Fest Ashburn on October 4th. Experience the best of Nepalese entertainment.');
    }
    
    // Update Twitter title
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'Neetesh Jung Kunwar USA Tour 2025 - 3E Entertainment');
    }
    
    // Update Twitter description
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', 'Book Neetesh Jung Kunwar for your venue! Available October - December 2025. Confirmed at DT Fest Ashburn on October 4th. Experience the best of Nepalese entertainment.');
    }
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Suspense fallback={<LoadingFallback />}>
        <NeeteshHeroSection />
        <NeeteshCitiesGrid />
        <BenefitsSection />
        <ContactSection />
      </Suspense>
    </motion.div>
  );
};

export default NeeteshTour;
